/** The roster of currently available experiments for the application. */
enum ExperimentKey {
  /** A key solely for use in testing. */
  Testing = "For use in testing",
  /** Removes the Confirmation step and books directly from the Scheduling step. Production Convert experience key. */
  ConfirmationPageRemoval = "obx-confirmation-page-removal",
  /** Removes the Confirmation step and books directly from the Scheduling step. Lower-environment Convert experience key. */
  ConfirmationPageRemovalDev = "obx-confirmation-removal-dev"
}

export default ExperimentKey;
